export const payment_types_lange={
    TH:{
        payment_data:"จัดการข้อมูลประเภทการชำระ",
        add_payment:"เพิ่มข้อมูลประเภทการชำระ",
        payment_id:"รหัสประเภทการชำระ",
        payment_description:"รายละเอียดประเภทการชำระ",
        payment_date:"วันที่ต้องชำระ",
        payment:"ประเภทการชำระ",
        payment_price:"ราคา",
        edit:"แก้ไข",
        delete:"ลบ",
        back_to_payment:"กลับไปหน้าแสดงข้อมูลประเภทการชำระ",
        alert_payment_description:"กรุณากรอกรายละเอียดประเภทการชำระ",
        alert_payment_date:"กรุณากเลือกวันที่",
        payment_date_error:"กรุณากเลือกวันที่ให้ถูกต้อง",
        alert_payment:"กรุณาเลือกประเภทการชำระ",
        alert_payment_price:"กรุณากรอกราคา",
        payment_price_error:"กรุณากรอกราคาให้ถูกต้อง",
        save_data:"บันทึกข้อมูล",
        no_internet:"เกิดข้อผิดพลาดในการดึงข้อมูล กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตของคุณ!",
        saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!" ,
        confirm_delete:"คุณต้องการลบข้อมูลประเภทการชำระนี้ใช่หรือไม่?"  ,
        warning_delete:"ข้อมูลถูกลบแล้วไม่สามารถย้อนกลับได้!",
        want_delete:"ฉันต้องการลบ",
        close:"ปิดหน้านี้" ,
        deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว!",
        search:"ค้นหา"
    },
    EN:{
        payment_data:"payment data",
        add_payment:"add payment data",
        payment_id:"payment ID",
        payment_description:"payment description",
        edit:"edit",
        delete:"delete",
        back_to_payment:"back to payment data",
        alert_payment_description:"please input payment description",
        save_data:"save data",
        no_internet:"something wrong please check your connection",
        saved:"data was saved!" ,
        confirm_delete:"Are you sure to delete this data?"  ,
        warning_delelte:"Deleted data can't recovery!",
        want_delete:"Delete this data",
        close:"Close this page",
        deleted:"data was deleted!",
        search:"search"
    }
}
